import script from "./diffOne.vue?vue&type=script&setup=true&lang=ts"
export * from "./diffOne.vue?vue&type=script&setup=true&lang=ts"

import "./diffOne.vue?vue&type=style&index=0&id=682fbbc2&lang=less"

const __exports__ = script;

export default __exports__